import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import AllApplications from "Main/Views/AllApplications";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
// import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
// const admin = localStorage.getItem("admin_details");

// @mui icons
import Icon from "@mui/material/Icon";
import Testimonials from "Main/Views/Testimonials";

import Blogs from "Main/Views/Blogs";
import WebContacts from "Main/Views/WebContacts";
import Notifications from "Main/Views/Notifications";
import AboutUs from "Main/Views/AboutUs";
import BlogCategories from "Main/Views/BlogCategories";
import Aluminis from "Main/Views/Aluminis";
import Events from "Main/Views/Events";
import Gallery from "Main/Views/Gallery";
import Courses from "Main/Views/Courses";
import FranchiseEnquiry from "Main/Views/FarnchiseEnquiry";
import SocialMedia from "Main/Views/SocialMedia";
import SchoolEnquiry from "Main/Views/SchoolEnquiry";
import Banners from "Main/Views/Banner";
import Exams from "Main/Views/Competitive_Exams";
import CountsList from "Main/Views/AboutUsCount";
import TeamsList from "Main/Views/Teams";
import FaqList from "Main/Views/Faq";
import AmenitiesList from "Main/Views/Amenities";
import NavbarTextList from "Main/Views/NavbarSlider";
import RequestDemoList from "Main/Views/RequestDemo";
import Projects from "Main/Views/Projects";
import Products from "Main/Views/Product";
import CareerCategories from "Main/Views/CareerCategories";
import Careers from "Main/Views/Career";
import TrustedBrands from "Main/Views/TrustedBrands";
import PrivateBrands from "Main/Views/PrivateBrands";
import BrandPages from "Main/Views/BrandPages";
import BrandProducts from "Main/Views/BrandProducts";
import SitePages from "Main/Views/SitePages";
import Leaders from "Main/Views/Leaders";

let users = localStorage.getItem("admin_details");
let user;

if (users) {
  user = JSON.parse(users);
}

let routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "About Us",
    key: "aboutus",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/aboutus",
    component: <AboutUs />,
  },
  {
    type: "collapse",
    name: "Leadership",
    key: "leaders",
    icon: <Icon fontSize="small">groups</Icon>,
    route: "/leaders",
    component: <Leaders />,
  },
  // {
  //   type: "collapse",
  //   name: "Teams",
  //   key: "teams",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/teams",
  //   component: <TeamsList />,
  // },
  // {
  //   type: "collapse",
  //   name: "Banner",
  //   key: "banner",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/banner",
  //   component: <Banners />,
  // },
  {
    type: "collapse",
    name: "Career Categories",
    key: "careercategories",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/careercategories",
    component: <CareerCategories />,
  },
  {
    type: "collapse",
    name: "Career",
    key: "career",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/careers",
    component: <Careers />,
  },
   {
    type: "collapse",
    name: "Career Enquiries",
    key: "careerenquiry",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/careerenquiry",
    component: <FranchiseEnquiry />,
  },
  {
    type: "collapse",
    name: "Blog Categories",
    key: "blogcategories",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/blogcategories",
    component: <BlogCategories />,
  },
  {
    type: "collapse",
    name: "Blogs",
    key: "blogs",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/blogs",
    component: <Blogs />,
  },
  {
    type: "collapse",
    name: "Trusted Brands",
    key: "trustedbrands",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/trustedbrands",
    component: <TrustedBrands />,
  },
  
   {
    type: "collapse",
    name: "Private Brands",
    key: "privatebrands",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/privatebrands",
    component: <PrivateBrands />,
  },
  

  {
    type: "collapse",
    name: "Products",
    key: "products",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/products",
    component: <Products />,
  },

  // Brand pages (Value Nest, Happinesque, Happy Wings, Versele-Laga with its
  // Happy Life / Lara sub-brands, Bird Feeders), the product ranges they own,
  // and the editable content pages.
  {
    type: "collapse",
    name: "Brand Pages",
    key: "brandpages",
    icon: <Icon fontSize="small">branding_watermark</Icon>,
    route: "/brandpages",
    component: <BrandPages />,
  },
  {
    type: "collapse",
    name: "Brand Products",
    key: "brandproducts",
    icon: <Icon fontSize="small">inventory_2</Icon>,
    route: "/brandproducts",
    component: <BrandProducts />,
  },
  {
    type: "collapse",
    name: "Website Pages",
    key: "sitepages",
    icon: <Icon fontSize="small">article</Icon>,
    route: "/sitepages",
    component: <SitePages />,
  },

  {
    type: "collapse",
    name: "Testimonials",
    key: "testimonials",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/testimonials",
    component: <Testimonials />,
  },
 
  
  {
    type: "collapse",
    name: "Contacts",
    key: "contacts",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/contacts",
    component: <WebContacts />,
  },

  // SUBJECT and LEVEL Routes
  // {
  //   type: "collapse",
  //   name: "Topics",
  //   key: "topics",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/topics",
  //   component: <Topics />,
  // },
  // {
  //   type: "collapse",
  //   name: "Levels",
  //   key: "levels",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/levels",
  //   component: <Levels />,
  // },
  // {
  //   type: "collapse",
  //   name: "Questions",
  //   key: "questions",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/questions",
  //   component: <Questions />,
  // },
  // {
  //   type: "collapse",
  //   name: "Test Series",
  //   key: "testseries",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/testseries",
  //   component: <TestSeries />,
  // },
  // {
  //   type: "collapse",
  //   name: "Users",
  //   key: "users",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/users",
  //   component: <Users />,
  // },
  // {
  //   type: "collapse",
  //   name: "Notifications",
  //   key: "notifications",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/notifications",
  //   component: <Notifications />,
  // },
];

let newRoutes = [];

if (user?.employee_type === "question_creater") {
  // console.log(user);
  routes.filter((item) => {
    if (
      item.route === "/questions" ||
      item.route === "/subjects" ||
      item.route === "/levels" ||
      item.route === "/topics" ||
      item.route === "/dashboard"
    ) {
      newRoutes.push(item);
    }
  });
}
if (user?.role == "superadmin") {
  newRoutes = routes;
}
routes = newRoutes;
export default routes;
